import ArtistPic1 from '../../img/artist/artist1_BW.jpg';
import ArtistPic2 from '../../img/artist/artist2_BW.jpg';

const artistData: Array<Artist> = [

    {   id: 1,
        img : ArtistPic1,
        name : "John Johnson Mendoza",
        info : "Kia Ora, I am John Johnson Mendoza I been staying to Christchurch New Zealand for almost 10 years, I’m the senior artist and the owner of Ink Kultura, I graduated Bachelor of Fine Arts in University of the East in The Philippines. I came here in New Zealand February 2013 to work in a construction than I met Dennis who’s been working as well in the construction and his been doing tattoo that time, he was the one who mentor me to do Tattoo, I started to practise in fake skin and free skin of my friends , after I got my Residency last 2017 I quit my job in construction and started doing Uber and Part time tattoo Artist in King Of Ink. After the Covid my wife started to register my tattoo last September 14, 2020, since she notices that I have a lot of clients and I can’t work to uber anymore. I Been enjoying doing Realism and my Favorite one is the Portrait, aside from doing tattoo I been enjoying also painting Portrait using Charcoal and on my free time I been roaming around Christchurch using my Motorcycle.",


    },

    {
        id: 2,
        img : ArtistPic2,
        name : "Jesmer Estrada",
        info : "I am Jesmer Estrada I’m the junior artist of Ink Kultura, I been staying in Christchurch for quite so long, I enjoyed drawing since I was a kid. I started do be interested in tattoo in 2018 but I don’t know where to start, my sister introduces me to Johnson since his been doing tattoo to her and Johnson taught me what machine to buy and the thing that use in tattooing. When Ink Kultura got a Minimal Promo Johnson told me to try to do tattoo for some clients and I also join Christchurch Tattoo Convention and it was great experience. I really enjoyed doing fine lines, Anime Character, and Traditional Japanese. On my free time I love to watch anime and lots of travel with my family and friends.",


    },


]

export default artistData;